import { UITable } from '../../components/table/ui-table';
import type { ComponentPlugin } from '../../components/ui-element.type';

/**
 * @class
 * @memberof SharedComponents
 * @classdesc Class for ui-table auto plugin.
 * @alias UITableAuto
 * @implements {ComponentPlugin}
 * @param {HTMLTableElement} target
 */
export class UITableAuto implements ComponentPlugin {
    private readonly target: UITable;

    constructor(target: UITable) {
        this.target = target;
    }

    /**
     * @inheritDoc
     */
    render(): void {
        this.target.table.classList.add('-auto');
    }
}

UITable.registerPlugin('auto', UITableAuto);
